<template>
<div>
  <toolbar />
  <zlick-navigation />
  <v-container v-if="!error && isInRole(['admin', 'telemarketing'])" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">{{ $t('select_product') }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">{{ $t('enter_code') }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">{{$t('order_info')}}</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="step1" v-model="valid" lazy-validation>
                <v-text-field v-model="subscriptionData.phone" validate-on-blur :rules="[v => !!v || $t('phone_required')]" :label="$t('phone_number')" required></v-text-field>
                <v-select
                  v-model="subscriptionData.selectedProduct"
                  :items="products"
                  item-text="name"
                  :rules="[v => !!v || $t('product_required')]"
                  validate-on-blur
                  :return-object="true"
                  :label="$t('product')"
                  required>
                </v-select>
                <v-btn :disabled="!valid" @click="submitProduct">
                  {{ $t('send_sms') }}
                </v-btn>
                <v-btn @click="clear">{{$t('cancel')}}</v-btn>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-form ref="step2" v-model="valid" lazy-validation>
              <v-text-field v-model="subscriptionData.phone" :label="$t('phone_number')" disabled></v-text-field>
              <v-text-field
                v-model="smsCode"
                :label="$t('verif_code')"
                required
                :rules="pinCodeRules"
                validate-on-blur>
              </v-text-field>
              <v-btn color="primary" @click="submitSmsCode">{{ $t('continue') }}</v-btn>
              <v-btn @click="clear" flat>{{ $t('cancel') }}</v-btn>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-alert
                :value="true"
                type="success"
              >
                {{ $t('order_confirmed') }}
              </v-alert>

              <v-list dense v-if="subscriptionData.selectedProduct">
                <v-list-tile>
                  <v-list-tile-content>{{ $t('phone_number') }}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ subscriptionData.phone }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{$t('product')}}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ subscriptionData.selectedProduct.name }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{$t('price')}}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ getPrice(0) }} €</v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-show="getPrice(1) != '-'">
                  <v-list-tile-content>{{$t('new_price')}}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ getPrice(1)}} €</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ $t('p_c_sms') }}:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ subscriptionData.smsText }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-btn color="primary" @click="clear">{{ $t('start_order') }}</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
  <v-snackbar
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    :multi-line="snackbar.multiline"
    v-model="snackbar.show"
  >
    {{ snackbar.text }}
      <v-btn
        color="white"
        flat
        @click="snackbar.show = false"
      >
        {{$t('close')}}
      </v-btn>
  </v-snackbar>
</div>
</template>

<script>
import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'
import AuthenticationService from '../services/AuthenticationService'
import Bugsnag from '../services/Bugsnag'
import ProductsService from '../services/ProductsService'
import SmsAuthService from '../services/smsAuthService'
import SubscriptionsService from '../services/SubscriptionsService'
import { mapState } from 'vuex'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data: () => ({
    states: ['active', 'inactive', 'past_due', 'canceled'],
    products: [],
    smsCode: '',
    smsChallengeId: '',
    pinCodeRules: [
      v => !!v || this.$t('pin_required'),
      v => v.length === 4 || this.$t('pin_length', { length: 4 })
    ],
    // save a new improved SMS text
    saveSms: false,
    error: null,
    valid: true,
    step: 0,
    subscriptionData: {
      phone: '',
      selectedProduct: null,
      smsText: ''
    },

    snackbar: {
      timeout: 0,
      color: 'success',
      mode: 'vertical',
      show: false,
      multiline: true
    }
  }),
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
    }
  },
  created () {
    this.getProducts()
  },

  computed: mapState({
    activeCognitoGroup: state => state.user.activeCognitoGroup
  }),

  watch: {
    activeCognitoGroup (newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`)
      this.getProducts()
    }
  },

  methods: {
    getPrice (index) {
      const product = this.subscriptionData.selectedProduct
      return (product && product.pricing[index] && (product.pricing[index].price * 0.01).toFixed(2)) || '-'
    },

    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },

    async getProducts () {
      try {
        const response = await ProductsService.getProducts()
        this.products = response
      } catch (error) {
        Bugsnag.send(error)
      }
    },
    // step 1: select the product and insert phone number
    async submitProduct () {
      if (!this.$refs.step1.validate()) return
      this.step = 2
      this.setSmsText()
      let response

      try {
        response = await SmsAuthService.start({
          providerId: this.subscriptionData.selectedProduct._providerId,
          userPhone: this.subscriptionData.phone,
          language: 'et'
        })
        this.smsChallengeId = response.data.challengeId
        this.snackbar.show = true
        this.snackbar.color = 'success'
        this.snackbar.text = 'SMS sent'
      } catch (error) {
        Bugsnag.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = error.response.data.message
      }
    },

    // step 2: input SMS code, edit SMS confirmation text
    async submitSmsCode () {
      if (!this.$refs.step2.validate()) return
      let response
      try {
        response = response = await SmsAuthService.complete({
          providerId: this.subscriptionData.selectedProduct._providerId,
          inputBody: this.smsCode,
          challengeId: this.smsChallengeId
        })
      } catch (error) {
        this.snackbar.show = true
        this.snackbar.color = 'error'
        if (error.response.status === 401) {
          this.snackbar.text = this.$t('wrong_pin')
        } else if (error.response.status === 429) {
          this.snackbar.text = this.$t('max_pin_attempts')
          this.step = 1
        } else {
          this.snackbar.text = error.response && error.response.data
            ? error.response.data.message
            : this.$t('something_went_wrong')
        }
      }

      try {
        await SubscriptionsService.createSubscription({
          userId: response.data.userId,
          productName: this.subscriptionData.selectedProduct.name
        })
        this.step = 3
        this.snackbar.show = true
        this.snackbar.color = 'success'
        this.snackbar.text = 'Order created successfully'
      } catch (error) {
        Bugsnag.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = error.response.data.message
        this.step = 1
      }
    },

    // stem 3: cancel / start over
    clear () {
      this.subscriptionData.phone = ''
      this.subscriptionData.smsText = ''
      this.subscriptionData.selectedProduct = null
      this.step = 1
      this.smsCode = ''
      this.smsChallenge = ''
    },

    setSmsText () {
      if (this.subscriptionData.smsText) return
      const product = this.subscriptionData.selectedProduct
      let smsText = product.smsText
      let nextPrice = (product.pricing && product.pricing[0].price) || 0
      if (product.pricing && product.pricing.length > 1) {
        nextPrice = product.pricing[1].price
      }
      // from cents to €
      const convertedPrice = (nextPrice * 0.01).toFixed(2)
      if (smsText && /\{\{price}}/.test(smsText)) {
        smsText = smsText.replace('{{price}}', convertedPrice)
      }
      this.subscriptionData.smsText = smsText
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Telemarketing.vue